export const theFunction = () => {
  const map = {
    'bokning17.branas.advanttest.se': ['', '', ''],
    'berget.chip.branas.se': ['', '', ''],
    'dalen.chip.branas.se': ['', '', ''],
    'byn.chip.branas.se': ['', '', ''],
    'branas.se': ['UA-5893735-5', '1179337702109576', 'G-JL1S2GRQCM'],
    'www.branas.se': ['UA-5893735-5', '1179337702109576', 'G-JL1S2GRQCM'],

    'bokning17.kungsberget.advanttest.se': ['', '', ''],
    'webchip.kungsberget.se': ['', '', ''],
    'kungsberget.se': ['UA-5893735-6', '1508535329161278', 'G-0GLC602TE0'],
    'www.kungsberget.se': ['UA-5893735-6', '1508535329161278', 'G-0GLC602TE0'],

    'bokning17.vallasen.advanttest.se': ['', '', ''],
    'chip.vallasen.se': ['', '', ''],
    'vallasen.advanttest.se': ['', '', ''],
    'test.vallasen.se': ['', '', ''],
    'www.vallasen.se': ['', '', ''],
    'vallasen.se': ['', '', ''],

    'bokning17.ulricehamn.advanttest.se': ['', '', ''],

    'localhost:8080': ['UA-117770016-1', '181347042533425', 'G-HITTAPA'],
  };

  const host = window.location.host;

  let analytics = map[host];

  if (!analytics) {
    console.log('Inget GA-id');
    analytics = ['', '', ''];
  }

  window.GA_ID = analytics[0] || '';
  window.GA4_ID = analytics[2] || '';
  window.FBP_ID = analytics[1] || '';
};

theFunction();

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/ga-id.js